import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-auto" }

import { ref, onMounted, toRefs, computed } from 'vue';
import { PERMISSIONS, GRADES_ORDER } from '@/enum';
import { can } from '@/composables';
import EditGradesModal from '@/components/Grades/EditGradesModal.vue';
import { useGradeStore, PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Grades',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props;
const { organizationId } = toRefs(props);
const profileStore = PersonStores.useUserProfileStore();
const gradesStore = useGradeStore();
const toggleEditGradesModal = ref(false);
const person_id = ref();

onMounted(async () => {
  await init();
});

const init = async (): Promise<void> => {
  toggleEditGradesModal.value = false;
  await profileStore.getAuthUserProfile();
  person_id.value = profileStore.person?.id ?? 0;
  await gradesStore.fetchPersonGrades(person_id.value);
};

const sortedGrades = computed(() => {
  const filtered = gradesStore.personGrades.filter((grade) => grade.organization_id === organizationId.value);

  return filtered.sort((a, b) => {
    const indexA = GRADES_ORDER.findIndex((g) => g === a.grade);
    const indexB = GRADES_ORDER.findIndex((g) => g === b.grade);

    const safeIndexA = indexA === -1 ? GRADES_ORDER.length : indexA;
    const safeIndexB = indexB === -1 ? GRADES_ORDER.length : indexB;

    return safeIndexA - safeIndexB;
  });
});

const gradesRow = computed(() => {
  if (sortedGrades.value.length === 0) return [];
  return [
    {
      id: 1,
      grades: sortedGrades.value.map((g) => g.grade).join(', '),
    },
  ];
});

const openEditModal = () => {
  toggleEditGradesModal.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Grades", -1)),
        _createElementVNode("div", _hoisted_1, [
          (_unref(can)([_unref(PERMISSIONS).GRADE_ASSIGN]))
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                type: "text",
                size: "small",
                text: "Edit Grades",
                "icon-left": "add",
                onClick: openEditModal
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: gradesRow.value,
          loading: _unref(gradesStore).loading,
          "data-key": "id",
          "responsive-layout": "scroll"
        }, {
          empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("All Grades.", -1)
          ]))]),
          default: _withCtx(() => [
            (gradesRow.value.length > 0)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  field: "grades",
                  header: "Grades"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      _: 1
    }),
    (_unref(can)([_unref(PERMISSIONS).GRADE_ASSIGN]) && sortedGrades.value && person_id.value)
      ? (_openBlock(), _createBlock(EditGradesModal, {
          key: 0,
          visible: toggleEditGradesModal.value,
          "person-id": person_id.value,
          "organization-id": _unref(organizationId),
          "organization-name": null,
          "current-grades": sortedGrades.value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (toggleEditGradesModal.value = false)),
          onSync: init
        }, null, 8, ["visible", "person-id", "organization-id", "current-grades"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})